export default {
  stepTitles: {
    reasonForVisit: 'Reason for visit',
    logIn: 'Log in',
    verifyPhoneNumber: 'Verify phone number',
    selectPatient: 'Select patient',
    patientInformation: 'Patient information',
    homeAddress: 'Home address',
    addAFamilyMember: 'Add a family member',
    finalize: 'Finalize your visit',
  },
  reasonForVisit: {
    whatsBringingYouIn: "What's bringing you in?",
    letUsKnowWhyYoureSeekingCare: "Let us know why you're seeking care.",
    describeTheReason: 'Describe the reason for the visit here.',
    whatsTheReasonVideoVisit: "What's the reason for the video visit?",
    describeTheReasonVideo: 'Describe the reason for the video visit here',
    whatsTheReasonAtHomeCare: "What's the reason for this at-home visit?",
    reasonForVisit: 'Reason for visit',
    emergency: {
      title: 'Possible Emergency',
      body: 'Your reason for visit could be a sign of a life-threatening emergency. Please review the guidelines for calling 911 and consider visiting the nearest emergency room.',
      viewGuidelines: 'View 911 guidelines',
    },
  },
  finalize: {
    lastStep: 'Last step! Everything look good?',
    pleaseConfirm: 'Please confirm your visit.',
    visitDetails: {
      header: 'Visit details',
      atHomeHealthcareHeader: 'At-home visit details',
      telemedHeader: 'Video visit details',
      patient: 'Patient',
      when: 'When',
      where: 'Where',
      payment: 'Payment',
      paymentMethod: {
        title: 'Payment method',
        insurance: 'Insurance',
        decidingLater: 'Deciding later',
        selfPayShort: 'Self-pay',
        selfPayFull: 'Self-pay: {{description}}',
        insuranceSkipped: 'Insurance skipped',
      },
      legalInPerson:
        "By clicking <strong>$t(bookingFlow:finalize.bookIt)</strong>, I agree to create an account and have read, understood, and agreed to Solv Health's <0>Terms of Service</0> and <1>Privacy Policy</1>.",
      legalTelemed:
        "By clicking <strong>$t(bookingFlow:finalize.bookIt)</strong>, I agree to Solv's <0>Terms of Service</0> and <1>Privacy Policy</1>. <br /> By clicking <strong>$t(bookingFlow:finalize.bookIt)</strong>, I give my consent for the use of telemedicine in my medical care and have read, understand, and agree to these <0>Terms</0>.",
    },
    bookIt: 'Book it',
    selectANewTime: 'Select a new time',
    timeNoLongerAvailable: 'Sorry, the time you selected is no longer available.',
  },
  numberLookup: {
    title: "Got it. What's your phone number?",
    subtitle: "Let's complete your booking.",
  },
  selectPatient: {
    title: 'Who is this visit for?',
    subtitle: 'Please select or add a patient for this appointment.',
  },
  newFamilyMember: {
    title: 'Who is this visit for?',
  },
  newAccountWho: {
    title: 'Who is this visit for?',
    subtitle: "To book your visit, we'll just need a few details about the patient.",
  },
  homeAddress: {
    title: "What's your address?",
    addressLine1: 'Address line 1',
    addressLine2: 'Address line 2',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    addressLine2Placeholder: 'Apt #',
  },
  newProfileDetails: {
    name: 'Name',
    first: 'First',
    last: 'Last',
    dob: 'Date of birth',
    mmddyyyy: 'MM/DD/YYYY',
    birthSex: 'Birth sex',
    female: 'Female',
    male: 'Male',
    other: 'Other',
    tellUsALittleAboutYourself: 'Tell us a little about yourself',
    pleaseFillInTheirDetails: 'Please fill in their details',
    emailTitle: 'Email address where we can reach you',
  },
  photoIdUpload: {
    skipForNow: 'Skip for now',
  },
  paymentMethod: {
    title: 'How do you plan to pay for your visit?',
    description: 'You can add your insurance later.',
    skipForNow: 'Skip for now',
  },
  addInsurance: {
    goAheadAndAddCard: 'Go ahead and add your insurance card',
    goAheadAndAddInfo: 'Go ahead and add your insurance info',
    willSendInsuranceShort: "We'll send your insurance to the clinic.",
    scanningYourInsurance: 'Scanning your insurance',
    yourInsuranceDetails: 'Your insurance details',
    completeInsuranceDetails: 'Complete your insurance details',
    haveAPhoto: 'Have a photo of the front of your card?',
    uploadImage: 'Upload image',
    addInsurance: 'Add insurance',
  },
};
